export default "/react/targetIcon-8f8b4f15.svg";